 
import { routes } from "../../../routers/routes";
import Breadcrumbs from "../../commonComponents/breadcrumbs";
import GridView from "../../commonComponents/gridView";

const CarTopFilterContainer = () => {
  return (
    <>
      <Breadcrumbs title="Car Shop" url={routes.Home.CarDemo1} mainClass="car-breadcrumbs-section" />
      <GridView type="car" sectionClass="car-shop-section car-product-section" filterTagsClass="car-list-header" side="no" gridSize={3} carShow={9} topFilter topFilterSidebar />
    </>
  );
};

export default CarTopFilterContainer;
